import { render, staticRenderFns } from "./MatchPagePar.vue?vue&type=template&id=a3b224c0&scoped=true&"
import script from "./MatchPagePar.vue?vue&type=script&lang=js&"
export * from "./MatchPagePar.vue?vue&type=script&lang=js&"
import style0 from "./MatchPagePar.vue?vue&type=style&index=0&id=a3b224c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b224c0",
  null
  
)

export default component.exports